import { Reveal, Eyebrow } from "./Reveal";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=1800&auto=format&fit=crop";

export const WhoWeAre = () => {
  return (
    <section id="about" data-testid="who-we-are-section" className="relative bg-[#F4F1EA] py-24 sm:py-32 lg:py-40 scroll-mt-20 overflow-hidden">
      <div className="absolute inset-0 parcel-bg opacity-[0.1] pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>Choose Me Properties</Eyebrow>
        </Reveal>
        <div className="mt-6 grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-6">
            <Reveal delay={0.05}>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#111513] leading-[1.1]">
                We look beyond <span className="italic text-[#A77A50]">the address.</span>
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-6 space-y-6">
            <Reveal delay={0.12}>
              <p className="text-lg sm:text-xl text-[#3E4742] leading-relaxed">
                A property&rsquo;s value isn&rsquo;t always limited to the home sitting on it today. Zoning,
                neighboring parcels, ownership patterns, access, infrastructure and redevelopment can change the
                conversation entirely.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="border-l-2 border-[#A77A50] pl-6 space-y-4">
                <p className="text-base text-[#5C665F] leading-relaxed">
                  Over the past several months, our work has included researching individual properties, land
                  development opportunities, neighboring parcels, potential assemblages, redevelopment possibilities,
                  title information, zoning considerations, ownership history, and the factors that can influence a
                  property&rsquo;s long-term potential.
                </p>
                <p className="text-base text-[#5C665F] leading-relaxed">
                  Not every property needs to be sold. Sometimes the first step is simply understanding what you own,
                  what may be changing around it, and what options could exist.
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.28}>
              <a
                href="#owners"
                data-testid="about-evaluate-link"
                className="group inline-flex items-center gap-2 text-[13px] font-semibold tracking-[0.12em] uppercase text-[#A77A50] hover:text-[#111513] transition-colors"
              >
                How we evaluate opportunities
                <span className="transition-transform group-hover:translate-x-1" aria-hidden="true">→</span>
              </a>
            </Reveal>
          </div>
        </div>
        <Reveal delay={0.15} className="mt-16 sm:mt-20">
          <div className="overflow-hidden lg:w-[calc(100%+6rem)] lg:-mr-24">
            <img
              src={ABOUT_IMG}
              alt="Contemporary Pacific Northwest home with clean architectural lines"
              loading="lazy"
              className="w-full aspect-[16/8] sm:aspect-[16/7] object-cover transition-transform duration-[1200ms] ease-out hover:scale-[1.025]"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
